import { useContext } from 'react'

import { ProfilesContext } from '@provider/Shared/ProfileProvider'

import { IProfileContext } from '@base/@types/providers/Shared/ProfileProvider'

export default function useProfiles(): IProfileContext {
  const context = useContext(ProfilesContext)

  return context
}
